<template>
  <div
    :id="`answer-${answer.id}`"
    class="multiple-choice-answer"
    :class="{
      selected: selected,
      'strike-through': strikeThrough,
      'answered-correctly': answeredCorrectly,
      'answered-incorrectly': answeredIncorrectly,
      'correct-answer': correctUnselected,
    }"
    aria-role="checkbox"
    tabindex="0"
    data-test="multiple-choice-answer"
    @click.stop="handleClick"
    @keydown.space.prevent="handleClick"
    @keydown.enter.prevent="handleClick"
  >
    <input
      v-model="selected"
      type="checkbox"
    />
    <label
      class="answer-label"
      :content="answer.content"
      v-html="answer.content"
    ></label>
    <span
      :class="{ rotated: strikeThrough }"
      data-test="strike-through-icon"
      @click.stop="toggleStrikeThrough"
      @keydown.enter.prevent="toggleStrikeThrough"
    >
      <icon
        name="cross-circled"
        class="strike-through-icon"
        tabindex="0"
      ></icon>
    </span>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    answer: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    isSimulationComplete: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      strikeThrough: false,
    };
  },
  computed: {
    answeredCorrectly() {
      return this.isSimulationComplete && this.selected && this.answer.correct;
    },
    answeredIncorrectly() {
      return this.isSimulationComplete && this.selected && !this.answer.correct;
    },
    correctUnselected() {
      return this.isSimulationComplete && !this.selected && this.answer.correct;
    },
  },
  mounted() {
    this.strikeThrough = this.$store.getters['answerStrikes/strikes'][this.answer.id];
  },
  methods: {
    handleClick() {
      if (this.isSimulationComplete) return;
      if (!this.strikeThrough) {
        this.$emit('selectAnswer', this.answer.id);
      }
    },
    toggleStrikeThrough() {
      if (this.isSimulationComplete) return;
      if (this.strikeThrough) {
        this.$store.dispatch('answerStrikes/removeStrike', this.answer.id);
      } else {
        this.$store.dispatch('answerStrikes/addStrike', this.answer.id);
        if(this.selected) {
          this.$emit('selectAnswer', null);
        }
      }
      this.strikeThrough = !this.strikeThrough;
      this.$emit('toggleStrikeThrough', this.answer, this.strikeThrough);
    },
  },
};
</script>

<style lang='scss' scoped>
.multiple-choice-answer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1.5rem;
  border: 1px solid #F4F4F4;
  margin-bottom: 1rem;
  box-shadow: 0px 2px 6px rgba(224, 224, 224, 0.4), 0px 5px 12px rgba(159, 159, 159, 0.06);
  border-radius: 4px;
  height: 5rem;
  font-size: 1.5rem;
  cursor: pointer;

  .answer-label {
    display: flex;
    cursor: pointer;
    padding-right: 1rem;

    ::v-deep p {
      margin-block-start: 0;
      margin-block-end: 0;
    }
  }
}

input {
  display: none;

  + label:before {
    height: 18px;
    width: 18px;
    min-width: 18px;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
    margin-top: 0.3rem;
    content: " ";
    display:inline-block;
    border-radius:50%;
    background-color: white;
    box-shadow: 0 0 0 3px white, 0 0 0 4px black;
  }

  &:checked + label:before {
    background-color: black;
  }
}

.answered-correctly {
  background: #d8e0f3;

  input {
    + label:before {
      background-color: #00B46D;
      box-shadow: 0 0 0 3px #00B46D, 0 0 0 4px #00B46D;
      background-image: url(/src/assets/icons/check-ffffff.svg);
    }
  }
}

.correct-answer {
  input {
    + label:before {
      background-color: #00B46D;
      box-shadow: 0 0 0 3px #00B46D, 0 0 0 4px #00B46D;
      background-image: url(/src/assets/icons/check-ffffff.svg);
    }
  }
}

.answered-incorrectly {
  background: #d8e0f3;

  input {
    + label:before {
      background-color: #DC3416;
      box-shadow: 0 0 0 3px #DC3416, 0 0 0 4px #DC3416;
      background-image: url(/src/assets/icons/cross-ffffff.svg);
    }
  }
}

 .strike-through > label {
  text-decoration: line-through;
}

.strike-through-icon {
  height: 24px;
  cursor: pointer;
}

.rotated img {
  transform: rotate(45deg);
}
</style>
